/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { OpenLearnMoreWindow } from '../../../core/store/actions';

@Component({
  selector: 'fm-roadside-assistance-marketing-modal',
  templateUrl: './roadside-assistance-marketing-modal.component.html',
  styleUrls: ['./roadside-assistance-marketing-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoadsideAssistanceMarketingModalComponent {
  constructor(private readonly _store: Store) {}

  public onLearnMoreClick(): void {
    this._store.dispatch(new OpenLearnMoreWindow());
  }
}
